import React, { useEffect, useRef, useState } from "react";
import { customerMasterHeader } from "../components/HeaderAttribute";
import MainLayout from "../components/MainLayout";
// import TableGrid from "../components/Table";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import CustomerPopup from "../popup-containers/CustomerPopup";
import MainPopup from "../popup-containers/MainPopup";
// import download from "../image/download.png";
import toast, { Toaster } from "react-hot-toast";
import { BindAPI, BindPostAPI, IUDAPI, ImageAPI } from "../services/APIConnection";
import GridPage from "../components/GridPage";
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
import PopUpButtons from "../components/PopUpButtons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import FileUpload from "../ReusableComponents/FileUpload";
import { useLocation } from "react-router-dom";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import { isValidMobileNumber } from "../utils/validation";
import Loader from "../ReusableComponents/Loader"

var createdBy = sessionStorage.getItem("createdBy"); // user session
var mstClientId = sessionStorage.getItem("MstClientId"); 


const CustomerMaster = () => {
  const location = useLocation();
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const customerNameRef = useRef(null);
  const addressRef = useRef(null);
  const countryRef = useRef(null);
  const stateRef = useRef(null);
  const branchProjectRef = useRef(null);
  const pinCodeRef = useRef(null);
  const contactPersonRef = useRef(null);
  const contactNumberRef = useRef(null);
  const contactPersonDesignationRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false); 
  const [customerFields, setCustomerFields] = useState({
    customerId: "CUS",
    customerName: "",
    address: "",
    country: "1",
    state: "",
    branchProject: "",
    pinCode: "",
    date: new Date(),
    commodities: null,
    showImage: "",
    contactPerson: "",
    contactPersonDesignation: "",
    contactNumber: "",
    contactPersonEmail: "",
  });

  const [customerFieldsError, setCustomerFieldsError] = useState({
    customerIdError: "",
    customerNameError: "",
    addressError: "",
    countryError: "",
    stateError: "",
    branchProjectError: "",
    pinCodeError: "",
    dateError: "",
    branchProjectError: "",
 showImageError: "",
  });
  useEffect(() => {
    const fetchData = async () => {
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().split("T")[0];
      setCustomerFields({ ...customerFields, date: formattedDate });
    };

    fetchData();
  }, []);
  const handleCustomerFieldsChange = (value, name) => {
    //
    console.log("Values:", value, name);
    setCustomerFields({
      ...customerFields,
      [name]: value,
    });
  };
  
  const [mstCustomerId, setMstCustomerId] = useState("");


  const [customerData, setCustomerData] = useState({});

  const [addScreenTitle, setAddScreenTitle] = useState(false);

  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);

  // View details start

  const [rowIndex, setRowIndex] = useState("");
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [submitVisibleButton, setSubmitVisibleButton] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [popViewdata, setPopViewdata] = useState({});
  const [getLocationDatas, setGetLocationDatas] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [customerdata2, setCustomerdata2] = useState({});

  // view details end

  const [bindCustomerMasterDatas, setBindCustomerMasterDatas] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // Set the initial items per page
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [bindCommoditiesDD, setBindCommoditiesDD] = useState([]);

  
  useEffect(() => {
    BindCustomerGridData();
  }, []);
  const BindCustomerGridData = async () => {

    const data = {
      mstClientId:mstClientId,
    };

     
     setIsLoading(true);
    const response = await BindPostAPI(data,"CustomerAPI/BindCustomer");
    console.log("Bindcustomer:",response)
    setBindCustomerMasterDatas(response.data.Table);
    setIsLoading(false);
  };
  useEffect(() => {
    const fetchData = async () => {
      binddrpCoutrydata();
      binddrpstatedata();
      binddrpMedicinesdrugsdata();
      BindCustomerGridData();
      
    };
    fetchData();
  }, []);

  const binddrpCoutrydata = async () => {
    try {
      const bindCountrydatadrp = await BindAPI("CountryAPI/BindCountry");
  
      const countryList = bindCountrydatadrp?.data?.Table;
  
      if (Array.isArray(countryList) && countryList.length > 0) {
        const countryDD = countryList.map((m) => ({
          value: m.MstCountryId,
          label: m.CountryName,
        }));
        setCountryBindDD(countryDD);
      } else {
        setCountryBindDD([]);
      }
    } catch (error) {
      console.error("Error fetching country data:", error);
    }
  };
  const binddrpstatedata = async () => {
    try {
      const bindStatedatadrp = await BindAPI("StateAPI/GetState/");
      if (bindStatedatadrp.data.Table.length > 0) {
        const stateDD = bindStatedatadrp.data.Table.map((m) => ({
          value: m.MstStateId,
          label: m.State,
        }));

        setStateBindDD(stateDD);
      } else {
        setStateBindDD([]);
      }
    } catch (error) {
      console.error("Error fetching state data:", error);
    }
  };

  const binddrpMedicinesdrugsdata = async () => {
    try {
      const bindMedicinesdrugsdatadrp = await BindAPI(
        "MasterDataAPI/BindAllMasterData"
      );

      console.log("Medicines:", bindMedicinesdrugsdatadrp.data);
      if (bindMedicinesdrugsdatadrp.data.Table10.length > 0) {
        const medicinesdrugsDD = bindMedicinesdrugsdatadrp.data.Table10.map(
          (m) => ({
            value: m.MstCommoditiesId,
            label: m.CommodityName_en,
          })
        );
        setBindCommoditiesDD(medicinesdrugsDD);
      } else {
        setBindCommoditiesDD([]);
      }
    } catch (error) {
      console.error("Error fetching Medicines Drugs data:", error);
    }
  };

  useEffect(() => {
    const getSelectedLocation = async () => {
      const locationResponse = await BindAPI("CityAPI/BindCity");
      setGetLocationDatas(locationResponse.data.Table);
      console.log("locationResponse", locationResponse);
    };
    getSelectedLocation();
  }, []);

  useEffect(() => {
     
    // Find the selected state in getLocationDatas
    const stateSelectedValue = getLocationDatas.find(
      (item) => item.MstStateId == customerFields.state // Replace with the desired MstStateId
    );
    console.log("stateSelectedValue", getLocationDatas, customerFields);
    if (stateSelectedValue) {
      const branchProjectLabels = getLocationDatas
        .filter((item) => item.MstStateId === stateSelectedValue.MstStateId)
        .map((item) => ({
          MstCityId: item.MstCityId,
          City: item.City,
        }));
      const branchProjectSelected = branchProjectLabels.map((LC) => ({
        value: LC.MstCityId, // Replace with the appropriate value
        label: LC.City,
      }));
      setBranchProjectBindDD(branchProjectSelected);
    } else {
    }
  }, [customerFields.state]);

  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true); // Add Screen title & button
    setUpdateScreenTitle(false); // Update Screen title & button
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split("T")[0];
    setCustomerFields({ ...customerFields, date: formattedDate });
  };

  const cancel = () => {
    setIsLoading(false)
    setVisibleAdd(false);
    setVisibleTable(true);
    setpopUpOpen(false);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    setSubmitBtnDisabled(false);
    setSubmitVisibleButton(false);
    clear();
  };
  const clear = () => {
    //Clear Customer data
    BindCustomerGridData();
    setCustomerFields({
      customerId: "CUS",
      customerName: "",
      address: "",
      country: "1",
      state: "",
      branchProject: "",
      pinCode: "",
      date: "",
      commodities: null,
      imageUploaded: "",
      contactPerson: "",
      contactPersonDesignation: "",
      contactNumber: "",
      contactPersonEmail: "",
    });
    setCustomerFieldsError({
      customerIdError: "",
      customerNameError: "",
      addressError: "",
      countryError: "",
      stateError: "",
      branchProjectError: "",
      pinCodeError: "",
      dateError: "",
      branchProjectError: "",
      sdpError: "",
      userIdError: "",
      showImageError: "",
    });
   
  };

 
  const handleShowImage = (showImage) => {

    console.log("image", showImage);
    
    // Set showImage to an empty string if showImage is falsy
    setCustomerFields({
      ...customerFields,
      showImage: showImage || "",  // This will set to showImage if it's truthy, else ""
    });
  
    console.log(customerFields);
  
    // Reset any error related to showImage
    setCustomerFieldsError({ ...customerFieldsError, showImageError: "" });
  };
  

  const handleEdit = async (rowIndex) => {
     
    setEditMode(true);
    setSelectedRowIndex(rowIndex);
    setVisibleAdd(true);
    setVisibleTable(false);
    setUpdateScreenTitle(true);
    setAddScreenTitle(false);
    var customerDate = bindCustomerMasterDatas[rowIndex].Date;
    const customerDatePart = customerDate.split("T")[0];
    setCustomerFields({
      ...customerFields,
      customerId: bindCustomerMasterDatas[rowIndex].CustomerId,
      customerName: bindCustomerMasterDatas[rowIndex].CustomerName,
      address: bindCustomerMasterDatas[rowIndex].Address,
      country: bindCustomerMasterDatas[rowIndex].MstCountryId,
      state: bindCustomerMasterDatas[rowIndex].MstStateId,
      branchProject: bindCustomerMasterDatas[rowIndex].MstCityId,
      pinCode: bindCustomerMasterDatas[rowIndex].Pincode,

      date: customerDatePart,
      commodities: bindCustomerMasterDatas[rowIndex].CustomerCommodities,
      showImage: bindCustomerMasterDatas[rowIndex].CustomerLogo,
      contactPerson:
        bindCustomerMasterDatas[rowIndex].ContactPerson,
      contactPersonDesignation:
        bindCustomerMasterDatas[rowIndex].Designation,
      contactNumber: bindCustomerMasterDatas[rowIndex].ContactNumber,
      contactPersonEmail: bindCustomerMasterDatas[rowIndex].EmailId,
    });

    setMstCustomerId(bindCustomerMasterDatas[rowIndex].MstCustomerId);
    
  };

  const handleCustomer = (rowIndex, flag) => {
    // Setting visibility in popup container

    setpopUpOpen(true);
    // setRowIndex(rowIndex);

    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(true);
    }

    setCustomerData(bindCustomerMasterDatas[rowIndex]);
    const CountryrowData = bindCustomerMasterDatas[rowIndex];
    const CountryInfo = countryBindDD.find(
      (ST) => ST.value === CountryrowData.MstCountryId
    );
    const resultCountry = {
      value: CountryrowData.MstCountryId,
      label: CountryInfo ? CountryInfo.label : "",
    };
    const StaterowData = bindCustomerMasterDatas[rowIndex];
    const StateInfo = stateBindDD.find(
      (ST) => ST.value === StaterowData.MstStateId
    );
    const resultState = {
      value: StaterowData.MstStateId,
      label: StateInfo ? StateInfo.label : "DefaultStateLabel",
    };
    const locationrowData = bindCustomerMasterDatas[rowIndex];
    const LocationInfo = getLocationDatas.find(
      (L) => L.MstLocationId === locationrowData.MstLocationId
    );
    const ResultLocation = {
      value: locationrowData.MstCityId,
      label: LocationInfo ? LocationInfo.LocationName_en : "DefaultStateLabel",
    };
    const medicinesDrugsData = bindCustomerMasterDatas[rowIndex];
    const medicinesDrugsInfo = bindCommoditiesDD.find(
      (ST) => ST.value === medicinesDrugsData.CustomerCommodities
    );
    const resultmedicinesDrugs = {
      value: medicinesDrugsData.CustomerCommodities,
      label: medicinesDrugsInfo ? medicinesDrugsInfo.label : "",
    };
    var customerDate = bindCustomerMasterDatas[rowIndex].Date;
    const customerDatePart = customerDate.split("T")[0];

    const Customerdata2 = [
      resultCountry,
      resultState,
      ResultLocation,
      resultmedicinesDrugs,
      customerDatePart,
    ];

    setCustomerdata2(Customerdata2);
  };

  const [branchProjectBindDD, setBranchProjectBindDD] = useState([]);
  const [stateBindDD, setStateBindDD] = useState([]);
  const [countryBindDD, setCountryBindDD] = useState([
    // { value: "1", label: "India" },
  ]);
  const createdBy = sessionStorage.getItem("createdBy");
  const mstClientId = sessionStorage.getItem("MstClientId"); 

  const validate = (flag) => {
    // Initialize an object to store validation errors for each field
    const errors = {};
  };
  const handleSubmit = async (items, flag) => {

    setSubmitBtnDisabled(true);
    // setIsLoading(true);
    if (flag == 1 || flag == 2) {
      // const customerIdValidate =
      const isFormError = {
        ...customerFieldsError,
       
        customerNameError:
          customerFields.customerName.length > 0
            ? /^[A-Za-z.' ]+$/.test(customerFields.customerName)
              ? ""
              : "Only Alphabet and space allowed"
            : "Enter Customer Name",
        addressError: customerFields.address.length > 0 ? "" : "Enter Address",
        countryError: customerFields.country ? "" : "Select Country",
        stateError: customerFields.state ? "" : "Select State",
        branchProjectError: customerFields.branchProject ? "" : "Select City",
        pinCodeError: customerFields.pinCode ? "" : "Enter Pin Code",
       
        contactPersonError:
          customerFields.contactPerson.length > 0
            ? /^[A-Za-z ]+$/.test(customerFields.contactPerson)
              ? ""
              : "Only Alphabet and space allowed"
            : "Enter Contact Person",

        contactNumberError:
          customerFields.contactNumber.length > 0
            ? /^\d{10,11}$/.test(customerFields.contactNumber)
              ? ""
              : "Enter a valid Contact Number"
            : "Enter Contact Number",
     

        contactPersonDesignationError:
          customerFields.contactPersonDesignation.length > 0
            ? /^[A-Za-z.' ]+$/.test(customerFields.contactPersonDesignation)
              ? ""
              : "Only Alphabet and space allowed"
            : "Enter Designation",
      };
      setCustomerFieldsError(isFormError);
      const isFormValid = Object.values(isFormError).every(
        (error) => error === ""
      );
      if (isFormValid) {
        setSubmitBtnDisabled(true);
       

        const customerPayload = [
          {
            mstCustomerId: mstCustomerId ? mstCustomerId : 0,
            mstClientId:mstClientId,
            CustomerName: customerFields.customerName,
            CustomerId: customerFields.customerId,
            MstCountryId: customerFields.country,
            MstStateId: customerFields.state,
            MstCityId: customerFields.branchProject,
            Address: customerFields.address,
            Pincode: customerFields.pinCode,
            CustomerLogo: customerFields.showImage,
            ContactPerson: customerFields.contactPerson,
            Designation:
              customerFields.contactPersonDesignation,
            ContactNumber: customerFields.contactNumber,
            EmailId: customerFields.contactPersonEmail,
            Date: customerFields.date,
            customerCommodities: customerFields.commodities,
            createdby: createdBy,
            flag: flag,
          },
        ];

        const response = await IUDAPI(
          customerPayload,
          "CustomerAPI/IUDCustomer"
        );

        if (flag == 1) {
          // Submit

          if (response.data.Table[0].Result === "S") {
            toast.success("Customer added successfully 👍", {
              duration: 2000,
              position: "top-center",
            });
            // setSubmitVisibleButton(true);
            // setCustomerFields({
            //   ...customerFields,
            //   customerId: response.data.Table1[0].CustomerId,
            // });
            setTimeout(cancel, 2000);
          } else {
            toast.error("Failed to add Customer data 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        } else if (flag == 2) {
          // Update
          if (response.data.Table[0].Result === "M") {
            toast.success("Customer updated successfully 👍", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          } else {
            toast.error("Failed to update Customer data 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        }
      } else {
        setSubmitBtnDisabled(false);
        setIsOpen(true);
        setIsLoading(false)
        if (isFormError.customerNameError && customerNameRef.current) {
          customerNameRef.current.focus();
        } else if (isFormError.addressError && addressRef.current) {
          addressRef.current.focus();
        } else if (isFormError.countryError && countryRef.current) {
          countryRef.current.focus();
        } else if (isFormError.stateError && stateRef.current) {
          stateRef.current.focus();
        } else if (isFormError.branchProjectError && branchProjectRef.current) {
          branchProjectRef.current.focus();
        } else if (isFormError.pinCodeError && pinCodeRef.current) {
          pinCodeRef.current.focus();
        } else if (isFormError.contactPersonError && contactPersonRef.current) {
          contactPersonRef.current.focus();
        } else if (
          isFormError.contactPersonDesignationError &&
          contactPersonDesignationRef.current
        ) {
          contactPersonDesignationRef.current.focus();
        } else if (isFormError.contactNumberError && contactNumberRef.current) {
          contactNumberRef.current.focus();
        }
        
      }
    } else {
      const data = {
        mstCustomerId: bindCustomerMasterDatas[items].MstCustomerId, 
        createdBy: createdBy,
        flag: flag,
      };
      const response = await IUDAPI([data], "CustomerAPI/IUDCustomer");
      if (flag == 3) {
        if (response.data.Table[0].Result === "D") {
          toast.success(
            "Customer data deleted successfully 🗑️",
            5000,
            cancel()
          );
        } else {
          toast.error("Failed to delete Customer data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      } else if (flag == 4) {
        if (response.data.Table[0].Result === "B") {
          toast.success(
            "Customer data Inactivated successfully! 👍",
            2000,
           
            cancel()
          );
          cancel();
        } else {
          toast.error("Failed to Inactivate Customer data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      } else if (flag == 5) {
        if (response.data.Table[0].Result === "UB") {
          toast.success(
           "Customer data activated successfully! 👍",
            2000,
            cancel()
          );
          cancel();
        } else {
          toast.error("Failed to activate Customer data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      }
    }
  };
  useEffect(() => {
    if (location.pathname == "/customermaster") {
      setAddScreenTitle(false);
      setVisibleTable(true);
      setVisibleAdd(false);
      // BindCustomerGridData();
      cancel();
    }
  }, [location]);
 

  return (
    <MainLayout pageName={"2"}>
        <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title="Customer"
          header={customerMasterHeader}
          records={bindCustomerMasterDatas}
          // currentPage={currentPage}
          blockView={true}
          handleEdit={handleEdit}
          handleAction={handleCustomer}
          showAdd={showAdd}
        />
        
      )}

      {visibleAdd && (
        <div class=" flex flex-col w-full">
          <div class={mainTable.clientMasterMainAdd}>
            <AddScreenTitle
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              title="Customer"
            />
            

            <div class={mainTable.addShadowScreen}>
              <div class={mainTable.mainContentScreen}>
                <form class={mainTable.formForClientMaster}>
                  <div class={mainTable.labelBold}>Customer Details</div>

                  <hr class={mainTable.horizontalLine}></hr>

                  <div class="grid gap-4 mb-6 md:grid-cols-3">
                    <InputText
                      inputType={"text"}
                      title={" Customer Id"}
                      name={" customerId"}
                      maxLength={20}
                      classStar={"text-red-500"}
                      content={customerFields.customerId}
                      controlFunc={(e) =>
                        setCustomerFields({
                          ...customerFields,
                          customerId: e.target.value,
                        })
                      }
                      disabled={true}
                    />

                    <InputText
                      ref={customerNameRef}
                      inputType={"text"}
                      title={"Customer Name"}
                      name={"customername"}
                      classStar={"text-red-500"}
                      maxLength={100}
                      content={customerFields.customerName}
                      controlFunc={(e) =>
                        setCustomerFields({
                          ...customerFields,
                          customerName: e.target.value,
                        })
                      }
                      controlFuncBlur={() => {
                        // setCustomerName(e.target.value);
                        setCustomerFieldsError((customerFieldsError) => ({
                          ...customerFieldsError,
                          customerNameError:
                            customerFields.customerName &&
                            customerFields.customerName.length > 0
                              ? /^[A-Za-z.' ]+$/.test(
                                  customerFields.customerName
                                )
                                ? ""
                                : "Only Alphabet and space allowed"
                              : "Enter Customer Name",
                        }));
                      }}
                      errorMessage={customerFieldsError.customerNameError}
                    />
                    

                    <InputText
                      ref={addressRef}
                      inputType={"text"}
                      title={"Address"}
                      maxLength={500}
                      name={"address"}
                      classStar={"text-red-500"}
                      content={customerFields.address}
                      controlFunc={(e) =>
                        setCustomerFields({
                          ...customerFields,
                          address: e.target.value,
                        })
                      }
                      controlFuncBlur={() => {
                        // setAddress(e.target.value);
                        setCustomerFieldsError((customerFieldsError) => ({
                          ...customerFieldsError,
                          addressError:
                            customerFields.address &&
                            customerFields.address.length > 0
                              ? /^[A-Za-z0-9, -/]+$/.test(
                                  customerFields.address
                                )
                                ? ""
                                : "Only Alphabets, numbers, commas, hyphens, and spaces allowed"
                              : "Enter Address",
                        }));
                      }}
                      errorMessage={customerFieldsError.addressError}
                    />
                   

                    <AutoDropDown
                      title="Country"
                      ref={countryRef}
                      options={countryBindDD}
                      placeholder="Select"
                      name="country"
                      selectedOption={countryBindDD.find(
                        (x) => x.value == customerFields.country
                      )}
                      Class="custom-class"
                      // tabIndex="1"
                      classStar="text-red-500"
                      controlFunc={(value, e) => {
                        handleCustomerFieldsChange(value.value, e.name);
                        
                      }}
                      controlFuncBlur={() => {
                        setCustomerFieldsError(() => ({
                          ...customerFieldsError,
                          countryError: customerFields.country
                            ? ""
                            : "Select Country",
                        }));
                      }}
                      errorMessage={customerFieldsError.countryError}
                    />
                 

                    <AutoDropDown
                      title="State"
                      ref={stateRef}
                      options={stateBindDD}
                      placeholder="Select"
                      name="state"
                      selectedOption={stateBindDD.find(
                        (x) => x.value == customerFields.state
                      )}
                      Class="p-0"
                      // tabIndex="1"
                      classStar="text-red-500"
                      controlFunc={(value, e) => {
                        handleCustomerFieldsChange(value.value, e.name);
                        setCustomerFields({
                          ...customerFields,
                          state: value.value,
                          branchProject: "",
                        });
                        setCustomerFieldsError({
                          ...customerFieldsError,
                          stateError: value ? "" : "Select State",
                        });

                      }}
                      controlFuncBlur={() => {
                        setCustomerFieldsError(() => ({
                          ...customerFieldsError,
                          stateError: customerFields.state
                            ? ""
                            : "Select State",
                        }));
                      }}
                      errorMessage={customerFieldsError.stateError}
                      
                    />
                   

                    <AutoDropDown
                      title="City"
                      ref={branchProjectRef}
                      options={branchProjectBindDD}
                      placeholder="Select"
                      name="branchProject"
                      selectedOption={
                        customerFields.branchProject
                          ? branchProjectBindDD.find(
                              (x) => x.value == customerFields.branchProject
                            )
                          : ""
                      }
                      Class="custom-class"
                      // tabIndex="1"
                      classStar="text-red-500"
                      controlFunc={(value, e) => {
                        handleCustomerFieldsChange(value.value, e.name);
                       
                      }}
                      controlFuncBlur={() => {
                        setCustomerFieldsError(() => ({
                          ...customerFieldsError,
                          branchProjectError: customerFields.branchProject
                            ? ""
                            : "Select City",
                        }));
                      }}
                      errorMessage={customerFieldsError.branchProjectError}
                      
                    />
                  

                    <InputText
                      ref={pinCodeRef}
                      inputType={"text"}
                      title={"Pin Code"}
                      name={"pinCode"}
                      classStar={"text-red-500"}
                      maxLength={6}
                      content={customerFields.pinCode}
                      controlFunc={(e) =>
                        setCustomerFields({
                          ...customerFields,
                          pinCode: e.target.value,
                        })
                      }
                      controlFuncBlur={() => {
                        setCustomerFieldsError((customerFieldsError) => ({
                          ...customerFieldsError,
                          pinCodeError:
                            customerFields.pinCode &&
                            customerFields.pinCode.length > 0
                              ? /^[\d\s]+$/.test(customerFields.pinCode)
                                ? ""
                                : "Only numbers allowed"
                              : "Enter Pin Code",
                        }));
                      }}
                      errorMessage={customerFieldsError.pinCodeError}
                      
                    />
                    

                    <InputText
                      inputType="date"
                      title="Date"
                      classStar="text-red-500"
                      name="date"
                      content={customerFields.date}
                      controlFunc={(e) =>
                        setCustomerFields({
                          ...customerFields,
                          date: e.target.value,
                        })
                      }
                    />
                    <div></div>
                    
                  </div>
                  <FileUpload
                    title="Logo"
                    apiCall="CustomerAPI/CustomerImageUpload"
                    modalName="CustomerLogo"
                    name="showImage"
                    disabledBtn={updateScreenTitle}
                    showImage={customerFields.showImage}
                    showImageData={handleShowImage}
                    imageUploadedError={customerFieldsError.showImageError}
                    limitMassage={
                      "Image size limit: 2MB. Accepted Image types:jpg, png, jpeg."
                    }
                    MAX_FILE_SIZE_MB={2}
                    ALLOWED_FORMATS={["image/jpeg", "image/jpg", "image/png"]}
                  />

                  <div class={mainTable.labelBold}>Contact Info</div>

                  <hr class={mainTable.horizontalLine}></hr>

                  <div class="grid gap-4 mb-6 md:grid-cols-3">
                    <InputText
                      ref={contactPersonRef}
                      inputType={"text"}
                      title={"Contact Person"}
                      name={"contactPerson"}
                      classStar={"text-red-500"}
                      maxLength={100}
                      content={customerFields.contactPerson}
                      controlFunc={(e) =>
                        setCustomerFields({
                          ...customerFields,
                          contactPerson: e.target.value,
                        })
                      }
                      controlFuncBlur={(e) => {
                        setCustomerFieldsError((customerFieldsError) => ({
                          ...customerFieldsError,
                          contactPersonError:
                            customerFields.contactPerson &&
                            customerFields.contactPerson.length > 0
                              ? /^[A-Za-z ]+$/.test(
                                  customerFields.contactPerson
                                )
                                ? ""
                                : "Only Alphabet and space allowed"
                              : "Enter Contact Person",
                        }));
                      }}
                      errorMessage={customerFieldsError.contactPersonError}
                    />
                    

                    <InputText
                      ref={contactPersonDesignationRef}
                      inputType={"text"}
                      title={"Designation"}
                      name={"contactPersonDesignation"}
                      classStar={"text-red-500"}
                      maxLength={50}
                      content={customerFields.contactPersonDesignation}
                      controlFunc={(e) =>
                        setCustomerFields({
                          ...customerFields,
                          contactPersonDesignation: e.target.value,
                        })
                      }
                      controlFuncBlur={(e) => {
                        setCustomerFieldsError((customerFieldsError) => ({
                          ...customerFieldsError,
                          contactPersonDesignationError:
                            customerFields.contactPersonDesignation &&
                            customerFields.contactPersonDesignation.length > 0
                              ? /^[A-Za-z ]+$/.test(
                                  customerFields.contactPersonDesignation
                                )
                                ? ""
                                : "Only Alphabet and space allowed"
                              : "Enter Designation",
                        }));
                      }}
                      errorMessage={
                        customerFieldsError.contactPersonDesignationError
                      }
                    />
                    

                    <InputText
                      ref={contactNumberRef}
                      inputType={"text"}
                      title={"Contact Number"}
                      name={"contactNumber"}
                      classStar={"text-red-500"}
                      maxLength={11}
                      content={customerFields.contactNumber}
                      controlFunc={(e) =>
                        setCustomerFields({
                          ...customerFields,
                          contactNumber: e.target.value,
                        })
                      }
                      controlFuncBlur={(e) => {
                      

                        setCustomerFieldsError((customerFieldsError) => ({
                          ...customerFieldsError,
                          contactNumberError:
                            customerFields.contactNumber &&
                            customerFields.contactNumber.length > 0
                              ? /^\d{10,11}$/.test(customerFields.contactNumber)
                                ? ""
                                : "Enter a valid Contact Number"
                              : "Enter Contact Number",
                        }));
                      }}
                      errorMessage={customerFieldsError.contactNumberError}
                    />
                    

                    <InputText
                      inputType={"text"}
                      title={"Email"}
                      name={"contactPersonEmail"}
                      // classStar={"text-red-500"}
                      content={customerFields.contactPersonEmail}
                      controlFunc={(e) =>
                        setCustomerFields({
                          ...customerFields,
                          contactPersonEmail: e.target.value,
                        })
                      }
                      
                    />
                    
                  </div>
                </form>

                
                <Buttons
                  addScreenTitle={addScreenTitle}
                  updateScreenTitle={updateScreenTitle}
                  handleSubmit={handleSubmit}
                  cancel={cancel}
                  disabledBtn={submitBtnDisabled || isLoading}
                />
                {submitVisibleButton && (
                  <div className="border p-2 flex flex-col items-center justify-center ">
                    <label className="flex gap-1  mb-2 text-sm font-medium text-neutral-700 ">
                      Customer Id :
                      <span className=" mb-2 text-sm font-bold text-neutral-700 ">
                        {customerFields.customerId}
                      </span>
                    </label>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={() => setpopUpOpen(true)}
      >
        <div>
          <PopUpScreenTitle
            title="Customer"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          
          <CustomerPopup data={customerData} data1={customerdata2} />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
        
      </MainPopup>
    </MainLayout>
  );
};

export default CustomerMaster;
